/**
 * SWR側のハッシュの一致を避けるためのリクエストユースケースごとのID一覧
 */
export const SWR_FETCHER_IDS = {
    GET_PRIZES_BY_GACHA_ID: 'GET_PRIZES_BY_GACHA_ID',
};
